import React, { useState, useEffect } from "react";

import { Col, Row, Modal, Button } from "antd";

function ModalScreenManagement({ showModal, toggleModal }) {
  const [isMultiScreenSupported, setMultiScreenSupported] = useState(false);

  const onFormSubmit = () => {
    toggleModal(false);
  };

  const [screenCount, setScreenCount] = React.useState(0);

  const [screenRef, setScreenRef] = React.useState([]);

  const [liveScreenRef, setLiveScreenRef] = React.useState();

  useEffect(() => {
    async function operate() {
      try {
        if ("getScreenDetails" in window) {
          const screenDetails = await window.getScreenDetails();

          screenDetails.addEventListener("screenschange", (event) => {
            const totalScreens = screenDetails.screens;

            console.log(totalScreens);
            setScreenCount(totalScreens.length);
            setScreenRef(totalScreens);
            setMultiScreenSupported(true);
          });
          try {
            const permission =
              (await navigator.permissions.query({ name: "window-management" }))
                .state === "granted"
                ? "Granted"
                : "No Permission";

            if (permission === "Granted") {
              const totalScreens = screenDetails.screens;

              console.log(totalScreens);
              setScreenCount(totalScreens.length);

              setScreenRef(totalScreens);
              setMultiScreenSupported(true);
            } else {
              console.log("Permission error", permission);

              setScreenCount(1);
              setScreenRef(window.screen);
              setMultiScreenSupported(false);
            }
          } catch (err) {
            console.error(err);

            setScreenCount(1);
            setScreenRef(window.screen);
            setMultiScreenSupported(false);
          }
        } else {
          setScreenCount(1);
          setScreenRef(window.screen);
          setMultiScreenSupported(false);
        }
      } catch (err) {
        console.error(err.name, err.message);
      }
    }
    operate();
  }, []);

  const handleScreenClick = (screen) => {
    console.log(screen);

    if (liveScreenRef && !liveScreenRef.closed) {
      console.log("window is already open", liveScreenRef);

      liveScreenRef.close();
    }

    if (isMultiScreenSupported) {
      if (true) {
        // the window is closed or doesn't exist
        console.log("Window is closed or doesn't exist");

        console.log(screen);

        const features =
          "width=" +
          screen.width +
          ",height=" +
          screen.height +
          "left=" +
          screen.availLeft +
          ",top=" +
          screen.availTop;

        // const newWindow =  window.open("/screen?fullScreen=1&displayCode=1", "_blank", features  );

        const newWindow = window.open(
          "/live-display?fullScreen=1&displayCode=1",
          "_blank",
          "width=" +
            screen.width +
            ",height=" +
            screen.height +
            ",left=" +
            screen.availLeft +
            ",top=" +
            screen.availTop
        );

        setLiveScreenRef(newWindow);
      }

      toggleModal(false);
    } else {
      const newwindow = window.open("/live-display", "Live Display", "", true);

      setLiveScreenRef(newwindow);
    }
  };

  return (
    <div>
      <Modal
        width={600}
        maskClosable={false}
        title="Screen Management"
        visible={showModal}
        onOk={() => onFormSubmit()}
        onCancel={() => toggleModal(false)}
        footer={null}
      >
        <Row gutter={16}>
          {screenCount === 1 && (
            <Col
              key={screenRef.label}
              span={(24 - (24 % screenCount)) / screenCount}
            >
              <div
                className="bg-gray-300"
                style={{
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div style={{ alignContent: "center" }}>
                  <img
                    src="https://ewr1.vultrobjects.com/cdn-sei/original/8ee350e1-5477-4a92-8039-c3bcaf43e178.png"
                    height={100}
                    width={140}
                  />
                </div>
                {"Computer Display"}
                <br></br>
                {}

                <Button
                  onClick={() => handleScreenClick(screenRef)}
                  type="primary"
                  block
                  style={{ marginTop: 10 }}
                >
                  Open Live Display
                </Button>
              </div>
            </Col>
          )}

          {screenCount > 1 &&
            screenRef?.map((screen) => (
              <Col
                key={screen.label}
                span={(24 - (24 % screenCount)) / screenCount}
              >
                <div
                  className="bg-gray-300"
                  style={{
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ alignContent: "center" }}>
                    <img
                      src="https://ewr1.vultrobjects.com/cdn-sei/original/8ee350e1-5477-4a92-8039-c3bcaf43e178.png"
                      height={100}
                      width={140}
                    />
                  </div>
                  {screen.isPrimary ? "Computer Display" : "TV Display"}
                  <br></br>
                  {screen && (screen.label === undefined || screen.label === "")
                    ? "No Name"
                    : screen?.label}

                  <Button
                    onClick={() => handleScreenClick(screen)}
                    type="primary"
                    block
                    style={{ marginTop: 10 }}
                  >
                    Open Live Display
                  </Button>
                </div>
              </Col>
            ))}
        </Row>
      </Modal>
    </div>
  );
}

export default ModalScreenManagement;
